module.exports = __webpack_public_path__ + "img/new-job.ed513e70.svg";